import React from 'react'

export class RouteErrorBoundary extends React.Component<
  { children: React.ReactNode; title?: string },
  { hasError: boolean; message: string }
> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false, message: '' }
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, message: String(error?.message || error || 'Unknown error') }
  }

  componentDidCatch(error: any) {
    console.error('[RouteErrorBoundary] Uncaught route error:', error)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="max-w-4xl mx-auto">
        <div className="border border-red-200 bg-red-50 text-red-800 rounded-lg p-4">
          <div className="font-bold">{this.props.title || 'This page crashed'}</div>
          <div className="text-sm mt-1">{this.state.message}</div>
          <div className="text-xs mt-2 text-red-700">
            Check browser console for details. This error boundary prevents a blank screen.
          </div>
        </div>
      </div>
    )
  }
}


